export default {"src":"/_next/static/media/BAR.e80853df.svg","height":18,"width":18};